export enum LeadWorkflowStatusEnum {
  NOT_MATCHED = "not_matched",
  MATCHED = "matched",
  REPLY_EMAIL_SENT = "reply_email_sent",
  QUESTIONNAIRE_RESPONSE_RECEIVED = "questionnaire_response_received",
  SMS_SENT = "sms_sent",
  FOLLOW_UP_EMAIL_SENT = "follow_up_email_sent",
  ALREADY_PROCESSED = "already_processed",
}
